module.exports = __webpack_public_path__ + "img/plus-gray.8308826f.svg";